import { render, staticRenderFns } from "./editinfo.vue?vue&type=template&id=56241847&scoped=true"
import script from "./editinfo.vue?vue&type=script&lang=js"
export * from "./editinfo.vue?vue&type=script&lang=js"
import style0 from "./editinfo.vue?vue&type=style&index=0&id=56241847&prod&lang=scss&scoped=true"
import style1 from "./editinfo.vue?vue&type=style&index=1&id=56241847&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56241847",
  null
  
)

export default component.exports